// @flow
import i18n from 'i18next';
import { KICKED_OUT } from '../../../../react/features/base/conference/actionTypes';
import { SET_ALERT } from './actionTypes';
export function setAlert(alert) {
    return {
        type: SET_ALERT,
        alert: { ...alert }
    };
}
export function getAlert(room, error, participant) {
    const displayUserName = participant?.getDisplayName() ?? '';
    switch (error) {
        case 'Not available':
            return {
                text: i18n.t('welcomepage.alert.notAvailable'),
                type: 'info',
                room
            };
        case 'Can\'t find room':
            return {
                text: i18n.t('welcomepage.alert.cantFindRoom'),
                type: 'error',
                room
            };
        case 'No connection':
            return {
                text: i18n.t('welcomepage.alert.noConnection'),
                type: 'error',
                room
            };
        case KICKED_OUT:
            return {
                text: displayUserName
                    ? i18n.t('welcomepage.alert.kicked', { name: displayUserName })
                    : i18n.t('welcomepage.alert.kickedGeneral'),
                type: 'error',
                room,
                participant
            };
        default:
            return {
                text: `Error: ${error}`,
                type: 'error',
                room
            };
    }
}
